import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useMutation } from '@apollo/client';
import { CUSTOMER_RESET_PASSWORD } from '../../lib/mutations';

const PasswordResetForm = ({ hasLabel }) => {
  const navigage = useNavigate();
  const [resetPassword, { data }] = useMutation(CUSTOMER_RESET_PASSWORD);
  const { token } = useParams();
  const location = useLocation();
  // State
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  useEffect(() => {
    if (data) {
      if (data?.customerResetPassword?.status?.code === 200) {
        toast.success(`Нууц үг амжилттай шинэчлэгдлээ та нэвтэрч орно уу`, {
          theme: 'colored'
        });
        navigage('/authentication/card/login');
      } else {
        toast.warning(`${data?.customerResetPassword?.status?.moreInfo}`, {
          theme: 'colored'
        });
      }
    }
  }, [data]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const password = searchParams.get('password');
    const confirmPassword = searchParams.get('confirmPassword');

    if (password && confirmPassword) {
      setFormData({
        password,
        confirmPassword
      });
    }
  }, [location.search]);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (formData.password === formData.confirmPassword) {
      resetPassword({
        variables: {
          newPassword: formData.password,
          resetToken: token
        }
      });
    } else {
      toast.warning(`Батлах нууц үг таарахгүй байна`, { theme: 'colored' });
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Шинэ нууц үг</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'New Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Хуучин нууц үг</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Confirm Password' : ''}
          value={formData.confirmPassword}
          name="confirmPassword"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Button
        type="submit"
        className="w-100"
        disabled={!formData.password || !formData.confirmPassword}
      >
        Нууц үг солих
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
